module.exports = __webpack_public_path__ + "images/help/icn-faq-todo@2x-ddfd6b427136005e74c1f39fabdb4b19.png";